import React from 'react';
import useLocalization from '../../../../../Localization';

const CancellationPolicyModal = () => {
  const {ApplicationString} = useLocalization();

  return (
    <div style={{marginBottom: '16px'}}>
      <div style={{maxWidth: '100%', padding: '0 12px'}}>
        <h4 style={{fontSize: '17px', fontWeight: 600}}>
          {ApplicationString['userMyEventsComponent.cancellationPolicy']}
        </h4>
        <ul
          style={{
            listStyleType: 'disc',
            paddingLeft: '20px',
            lineHeight: '1.6',
          }}>
          <li style={{marginBottom: '12px'}}>
            <strong>
              {
                ApplicationString[
                  'userMyEventsComponent.cancellationPolicy.title1'
                ]
              }
            </strong>{' '}
            {
              ApplicationString[
                'userMyEventsComponent.cancellationPolicy.content1'
              ]
            }
          </li>

          <li style={{marginBottom: '12px'}}>
            <strong>
              {
                ApplicationString[
                  'userMyEventsComponent.cancellationPolicy.title2'
                ]
              }
            </strong>{' '}
            {
              ApplicationString[
                'userMyEventsComponent.cancellationPolicy.content2'
              ]
            }
          </li>

          <li style={{marginBottom: '12px'}}>
            <strong>
              {
                ApplicationString[
                  'userMyEventsComponent.cancellationPolicy.title3'
                ]
              }
            </strong>{' '}
            {
              ApplicationString[
                'userMyEventsComponent.cancellationPolicy.content3'
              ]
            }
          </li>

          <li style={{marginBottom: '12px'}}>
            <strong>
              {
                ApplicationString[
                  'userMyEventsComponent.cancellationPolicy.title4'
                ]
              }
            </strong>{' '}
            {
              ApplicationString[
                'userMyEventsComponent.cancellationPolicy.content4'
              ]
            }
          </li>

          <li style={{marginBottom: '12px'}}>
            <strong>
              {
                ApplicationString[
                  'userMyEventsComponent.cancellationPolicy.title5'
                ]
              }
            </strong>{' '}
            {
              ApplicationString[
                'userMyEventsComponent.cancellationPolicy.content5'
              ]
            }
          </li>
          <li
            style={{marginBottom: '12px'}}
            dangerouslySetInnerHTML={{
              __html:
                ApplicationString[
                  'userMyEventsComponent.cancellationPolicy.content6'
                ],
            }}></li>
        </ul>
      </div>
    </div>
  );
};

export default CancellationPolicyModal;
